/**
 * Custom dialog for login pages.
 *
 * Author: Bounlith Sirivong <bounlith.sirivong@ircamamplify.com>
 * Copyright © Ircam Amplify 2026
 */

import {
  Description,
  Dialog,
  DialogPanel,
  DialogTitle,
} from '@headlessui/react'
import './LoginDialog.css'

interface LoginDialogProps {
  title: string
  message: string | null | undefined
  onClose: () => void
  open: boolean
  onClick?: () => void
}
const LoginDialog = (props: LoginDialogProps) => (
  <Dialog className="login-dialog" open={props.open} onClose={props.onClose}>
    <div className="login-dialog-overlay" />
    <div className="login-dialog-backdrop">
      <DialogPanel className="login-dialog-panel">
        <DialogTitle>{props.title}</DialogTitle>
        <Description className="login-dialog-description">
          {props.message}
        </Description>

        <button
          className={
            'ircam-button button button-regular button-dark ' +
            'login-dialog-button'
          }
          type="button"
          onClick={props.onClick}
        >
          <div className="button-label">OK</div>
        </button>
      </DialogPanel>
    </div>
  </Dialog>
)

export default LoginDialog
